import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { BranchesService } from "../../super-management/branch/branches.service";

/** תת־הקשר PH במסך /printer: תלת־מימד מול "הדפסה במשלוח" (מוצרים/הזמנות לפי type) */
export type PhPrintDomain = '3d' | 'delivery';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  branches: any[] = []; // Array to store fetched branches
  private ClusterSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private printingServiceSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private branchSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private productSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private phPrintDomainSubject: BehaviorSubject<PhPrintDomain> = new BehaviorSubject<PhPrintDomain>(this.readPhPrintDomainFromStorage());
  private triggerOpenPreviewDialog = new Subject<void>();
  triggerOpenPreviewDialog$ = this.triggerOpenPreviewDialog.asObservable();
  private fixProductsOrderCreatedSource = new Subject<void>();
  fixProductsOrderCreated$ = this.fixProductsOrderCreatedSource.asObservable();
  private pendingOrderIncrementSubject = new Subject<void>();
  private pendingOrderDecrementSubject = new Subject<void>();
  private phOrderCreatedSource = new Subject<void>();
  phOrderCreated$ = this.phOrderCreatedSource.asObservable();

  constructor(
    private branchesService: BranchesService,
  ) { }

  private readPhPrintDomainFromStorage(): PhPrintDomain {
    try {
      return localStorage.getItem('phPrintDomain') === '3d' ? '3d' : 'delivery';
    } catch {
      return 'delivery';
    }
  }

  /** 3Dprint בנפרד מ"הדפסה במשלוח" (מסך /printer וניווט מנהל) */
  setPhPrintDomain(value: PhPrintDomain): void {
    try {
      localStorage.setItem('phPrintDomain', value);
    } catch {
      /* empty */
    }
    this.phPrintDomainSubject.next(value);
  }

  getPhPrintDomain(): Observable<PhPrintDomain> {
    return this.phPrintDomainSubject.asObservable();
  }

  getPhPrintDomainSnapshot(): PhPrintDomain {
    return this.phPrintDomainSubject.value;
  }
  // Cluster
  setCluster(value: string): void {
    if (!value) {
      return;
    }
    this.ClusterSubject.next(value);
  }

  getCluster(): Observable<string> {
    return this.ClusterSubject.asObservable();
  }

  // PrintingService
  setPrintingService(value: string): void {
    if (!value) {
      return;
    }
    this.printingServiceSubject.next(value);
  }

  getPrintingService(): Observable<string> {
    return this.printingServiceSubject.asObservable();
  }

  // Branch
  setBranch(value: string): void {
    if (!value) {
      return;
    }
    this.branchSubject.next(value);
  }

  getBranch(): Observable<string> {
    return this.branchSubject.asObservable();
  }

  // Product
  setProduct(value: string): void {
    if (!value) {
      return;
    }
    this.productSubject.next(value);
  }

  getProduct(): Observable<string> {
    return this.productSubject.asObservable();
  }

  async fetchAndTransformBranches(): Promise<{ name: string; systems: string[] }[]> {
    try {
      const pretransformedBranches = await this.branchesService.getAllBranches().toPromise();

      if (!pretransformedBranches || !Array.isArray(pretransformedBranches)) {
        return [];
      }

      const transformedBranches = pretransformedBranches.map(branch => {
        const systems: string[] = [];
        if (branch.isExpress) {
          systems.push('express');
        }
        if (branch.isPlotter) {
          systems.push('plotter');
        }
        // if (branch.isPh) {
        //   systems.push('ph');
        // }
        return { name: branch.name, systems };
      });
      return transformedBranches;
    } catch (error) {
      console.error('Error fetching and transforming branches:', error);
      throw error;
    }
  }

  getPrintingServices(): { name: string }[] {
    return [
      { name: 'express' },
      { name: 'plotter' },
      { name: 'ph' }
    ];
  }

  triggerPreviewDialog() {
    this.triggerOpenPreviewDialog.next();
  }

  notifyFixProductsOrderCreated() {
    this.fixProductsOrderCreatedSource.next();
  }

  // pending orders

  notifyPendingOrderIncrement() {
    this.pendingOrderIncrementSubject.next();
  }

  getPendingOrderIncrementListener() {
    return this.pendingOrderIncrementSubject.asObservable();
  }

  notifyPendingOrderDecrement() {
    this.pendingOrderDecrementSubject.next();
  }

  getPendingOrderDecrementListener() {
    return this.pendingOrderDecrementSubject.asObservable();
  }

  // ph order

  notifyPhOrderCreated() {
    this.phOrderCreatedSource.next();
  }
}
